import { render, staticRenderFns } from "./scorm.vue?vue&type=template&id=45859e30&scoped=true"
import script from "./scorm.vue?vue&type=script&lang=js"
export * from "./scorm.vue?vue&type=script&lang=js"
import style0 from "./scorm.vue?vue&type=style&index=0&id=45859e30&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45859e30",
  null
  
)

export default component.exports